

import get      from '../../fn/modules/get.js';
import create   from '../../dom/modules/create.js';
import closest  from '../../dom/modules/closest.js';
import events   from '../../dom/modules/events.js';
import { requestGet } from '../../dom/modules/request.js';
import { enterFullscreen } from '../../dom/modules/fullscreen.js';

const url = window.config.combined_slideshow;
let n = 0;

function activate(href) {
    const element = document.getElementById('fullscreen-slide-show');

    const active = element
        .querySelector('[src="' + href + '"]')
        .closest('slide-show > *');

    const fullscreenchange = events('fullscreenchange', element)
    .each((e) => {
        element.style.display = '';
        fullscreenchange.stop();
    });

    element.active = active;
    // Safari wont put things into fullscreen that are display:none at time of
    // enterFullscreen(). Poor bugger. Give it a helping hand.
    element.style.display = 'block';

    enterFullscreen(element);
}

if (url) {
    events('click', document)
    .each((e) => {
        const target = e.target;
        const a      = target.closest('[target="fullscreen-slide-show"]');

        if (!a) { return; }

        if (++n < 2) {
            a.classList.add('requested');

            requestGet(url)
            .then((html) => {
                a.classList.remove('requested');

                const fragment = create('fragment', html);
                document.body.append(fragment);
                // Safari wont respond to this immediately, we must wait a frame
                requestAnimationFrame(() => activate(a.href));
            });
        }
        else {
            activate(a.href);
        }

        e.preventDefault();
    });
}
